import { put, select } from 'redux-saga/effects';
import { photoCaptureIntelligentDamageDetectionFailureAction, photoCaptureIntelligentDamageDetectionGetRequestAction } from '../actions';
import { getPhotoCaptureCompanyCode, getInstanceReferenceId, getProcessedDamageDetectionRequestIds, getIsPolling } from '../selectors';
import { getErrorMessagesBasedOnStatusCode } from '../utilities';
/**
 * Saga triggered when a SignalR damage notification is received.
 *
 * Dispatches a GET damage detection call for the notified requestId only once —
 * if the requestId has already been processed (i.e. a GET was previously dispatched
 * for it), the saga exits early to prevent duplicate calls.
 */
export function* intelligentPhotoCaptureDamageNotificationReceivedSaga(action) {
    try {
        const notification = action.payload.notification;
        const requestId = notification.requestId || notification.RequestId || '';
        if (!requestId) {
            return;
        }
        const processedRequestIds = yield select(getProcessedDamageDetectionRequestIds);
        if (processedRequestIds.includes(requestId)) {
            return;
        }
        const companyCode = yield select(getPhotoCaptureCompanyCode);
        const instanceReferenceId = yield select(getInstanceReferenceId);
        const isPolling = yield select(getIsPolling);
        // Parse iterationId from requestId (format: "${contextId}_${iterationId}") so that
        // intelligentDamageDetectionSuccessSaga can set damageCallStatus=COMPLETED for this
        // iteration, keeping the Organizing/Analyzing phase alive until the GET call finishes.
        const requestIdParts = requestId.split('_');
        const parsedIterationId = parseInt(requestIdParts[requestIdParts.length - 1], 10);
        const iterationId = isNaN(parsedIterationId) ? undefined : parsedIterationId;
        yield put(photoCaptureIntelligentDamageDetectionGetRequestAction(companyCode, requestId, instanceReferenceId, isPolling, iterationId));
    }
    catch (error) {
        const errorMessage = getErrorMessagesBasedOnStatusCode(error);
        yield put(photoCaptureIntelligentDamageDetectionFailureAction(errorMessage));
    }
}
//# sourceMappingURL=intelligentPhotoCaptureDamageNotificationReceivedSaga.js.map